import React from 'react'
import { Checkbox, message, Button, notification, Input, Skeleton } from 'antd';
import Config from "../../config/Config";
import WidgetAjax from '../../widget/WidgetAjax';
import JobInfo from './JobInfo';
import JobTable from '../com/job/scrollCardTable';
import EventBus from "../../frame/eventBus";
import NoData from '../com/NoData';
import { PlusSquareOutlined, CaretDownOutlined } from '@ant-design/icons';
import { tagRedirect, getSalaryDisplay } from '../com//utils'
const CheckboxGroup = Checkbox.Group;
let path = Config.getBasePath();
let filePath = Config.getFilePath();
class sendNotice extends React.Component {
  constructor(props) {
    super(props)
    const search = window.location.search;
    const params = new URLSearchParams(search);
    const key = params.get('job_key');

    this.state = {
      key,
      data: [],
      checkedList: []
    }
  }
  async componentDidMount() {
    this.job_similar();
  }

  /**
   * 相似岗位
   */
  job_similar = () => {
    const { key } = this.state;
    let params = {
      type: 'labor',
      job_id: key,
      page: 1,
      records: 5
    }
    const onSimilar = (res) => {
      if (res.status == 0) {
        this.setState({ data: res.results });
      }
    }
    WidgetAjax.ajax({ url: path + '/recommend/job_similar', params, callback: onSimilar });
  }

  favor = (data) => {
    let params = {
      job_id: data?.id,
    }
    const onFavor = (res) => {
      if (res.status == 0) {
        message.success("成功!");
        this.job_similar();
      } else {
        message.error("失败");
      }
    }
    let url = data?.favor ? '/job/unfavor' : '/job/favor';
    WidgetAjax.ajax({ url: path + url, params, callback: onFavor });

  }

  application_add = (id) => {
    const { checkedList } = this.state;
    let params = {}
    if (id) {
      params['job_id'] = id
    } else if (checkedList && checkedList.length > 0) {
      params['job_ids'] = checkedList
    } else {
      return message.info("请选择数据!")
    }
    WidgetAjax.ajax({
      url: path + "/job/application_add",
      params,
      callback: (res) => {
        if (res.status == 0) {
          message.success('恭喜您，投递成功！');
          this.job_similar();
        } else {
          message.error("投递失败！" + res.message);
        }
      },
    });
  }


  onCheckChange = (value) => {
    this.setState({ checkedList: value });
  }

  allChecked = () => {
    const { checkedList, data } = this.state;
    if (checkedList && data && data.length == checkedList.length) {
      this.setState({ checkedList: [] })
    } else {
      let keyList = data.map(item => String(item.id));
      this.setState({ checkedList: keyList });
    }
  }


  render() {
    const { data, checkedList } = this.state;
    return <div component-data="sendNotice">
      <div className='inner'>
        <div className='notice_box'>
          <div className='notice_mes sf-page-tool-between'>
            <div className='message_box'>
              <img src={require("../../img/pinzhunzhun/job_info/icon-succeed.png")} />
              <text>恭喜您，投递成功！</text>
            </div>
            <div className='marketing_box'>
              <img src={require("../../img/pinzhunzhun/job_info/marketing-qr.png")} />
              <div className='title'>更多求职信息</div>
              <div className='tips'>请下载“聘准准APP”</div>
            </div>
          </div>
          <div className='likeness_job'>
            <div className='likeness_head sf-page-tool-between'>
              <div className='likeness_head_title'>
                <img src={require("../../img/pinzhunzhun/job_info/icon-likeness.png")} />
                相似职位
              </div>
              <div>
                <Checkbox onChange={this.allChecked} >全选</Checkbox>
                <Button type="primary" onClick={() => this.application_add()}>一键申请 {checkedList && checkedList.length > 0 ? checkedList.length : null}</Button>
              </div>
            </div>

            <div className='likeness_table'>
              <CheckboxGroup onChange={this.onCheckChange} value={checkedList}  >
                {
                  data && ((data.map((item) => {
                    return <div className='likeness_job_item'>
                      <Checkbox value={item?.id} key={item.id} />
                      <div className='job_box_item' onClick={() => { tagRedirect({ job_key: item?.id }, 'JobDetails') }}>

                        <div className='job_item_head '>
                          <div className='job_info_detail'>
                            <div className='job_title'>{item?.JOBNAME}</div>
                            <div className='job_salary'>
                              {getSalaryDisplay(item?.SALFROM, item?.SALTO)}
                              {item?.SALPAY == "11" ? "元/小时" : ""}
                              {item?.SALPAY == "12" ? "元/天" : ""}
                              {item?.SALPAY == "13" ? "元/周" : ""}
                            </div>
                          </div>

                        </div>

                        <div className='sf-page-tool-between' style={{ padding: '10px 20px' }}>

                          <div>
                            <div className='job_tag_box'>
                              {item?.DISTRICT_CN ? <div className='job_tag'>{item.DISTRICT_CN}</div> : ""}
                              {item.REQWE_CN ? <div className='job_tag'>{item.REQWE_CN}</div> : ""}
                              {item.REQEDU_CN ? <div className='job_tag'>{item.REQEDU_CN}</div> : ""}
                              {!item.REQAGEFROM && !item.REQAGETO ? <div className='job_tag'>{'不限年龄'}</div> : ""}
                              {item.REQAGEFROM && !item.REQAGETO ? <div className='job_tag'>{item.REQAGEFROM + '岁以上'}</div> : ""}
                              {!item.REQAGEFROM && item.REQAGETO ? <div className='job_tag'>{item.REQAGETO + '岁以内'}</div> : ""}
                              {item.REQAGEFROM && item.REQAGETO ? <div className='job_tag'>{item.REQAGEFROM + ' - ' + item.REQAGETO + '岁'}</div> : ""}

                            </div>
                            <div className='ent_box'>
                              <img className='ent_logo'
                                src={item?.ENTLOGO ? filePath + 'enterprise/M' + item.enterprise_id + '.png' : require('../../img/pinzhunzhun/dataSource/ent_logo.png')}
                              />

                              <div className='ent_title'>{item?.ENTNAME}</div>
                              <div className='ent_detail'>
                                <div className='ellipsis-text' title={item?.INDTYPE_CN}>{item.INDTYPE_CN ? item.INDTYPE_CN : ""}</div>
                                {item.SCALE_CN ? <div>|</div> : <div >|</div>}
                                {item.SCALE_CN ? item.SCALE_CN : ""}
                                {item.ENTTYPE_CN ? <div >|</div> : ""}
                                {item.ENTTYPE_CN ? item.ENTTYPE_CN : ""}
                              </div>
                            </div>

                          </div>


                          <div className='job-detail-op'>
                            {
                              item?.favor ?
                                <a onClick={() => { this.favor(item) }} className='op-btn op-btn-likes'>取消收藏</a>
                                :
                                <a onClick={() => { this.favor(item) }} className='op-btn op-btn-like'>收藏</a>
                            }
                            {
                              item?.application ?
                                <Button disabled>已申请</Button>
                                :
                                <Button onClick={() => { this.application_add(item?.id) }} type="primary">申请职位</Button>
                            }
                          </div>
                        </div>
                      </div>

                    </div>
                  })))
                }
              </CheckboxGroup>
            </div>
          </div>
        </div>
      </div >
    </div >
  }
}

export default sendNotice;